import { render, staticRenderFns } from "./ChangedBlock.vue?vue&type=template&id=722b2f26&scoped=true&"
import script from "./ChangedBlock.vue?vue&type=script&lang=js&"
export * from "./ChangedBlock.vue?vue&type=script&lang=js&"
import style0 from "./ChangedBlock.vue?vue&type=style&index=0&id=722b2f26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722b2f26",
  null
  
)

export default component.exports